import React, { useEffect, useState } from "react";
import "../../commoncss/Common.css";
import Cookies from "universal-cookie";
import { useToast } from "../../commoncomponents/ToastProvider";
import Loader from "../../commoncomponents/Loader";

const Admindata = () => {
  const [getFilter, setFilter] = useState({});
  const [getData, setData] = useState([{}]);
  const { showToast } = useToast();
  const [getAgentList, setAgentList] = useState([{}]);
  const [getHeaderForm, setHeaderForm] = useState(JSON.stringify({}));
  const [loading, setLoading] = useState(false);

  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 20,
    page: 0,
  });

  const [getTotalCount, setTotalCount] = useState(0);

  const cookie = new Cookies();

  const cleanFilters = (filters) => {
    try {
      if (!filters || typeof filters !== "object") {
        return {};
      }

      const cleanedFilter = Object.assign({}, filters);
      const filterKeys = Object.keys(filters);

      for (let i = 0; i < filterKeys.length; i++) {
        if (
          !filters[filterKeys[i]] ||
          typeof filters[filterKeys[i]] !== "object"
        ) {
          delete cleanedFilter[filterKeys[i]];
          continue;
        }

        const subFilterKeys = Object.keys(filters[filterKeys[i]]);
        for (let j = 0; j < subFilterKeys.length; j++) {
          if (
            filters[filterKeys[i]][subFilterKeys[j]] === 0 ||
            filters[filterKeys[i]][subFilterKeys[j]] === "" ||
            filters[filterKeys[i]][subFilterKeys[j]] === null ||
            filters[filterKeys[i]][subFilterKeys[j]] === undefined
          ) {
            delete cleanedFilter[filterKeys[i]];
          }
        }
      }
      return cleanedFilter;
    } catch (error) {
      console.error("Error cleaning filters:", error);
      return {};
    }
  };

  const fetchFilteredEnteries = async () => {
    setLoading(true);
    try {
      const cleanedFilter = cleanFilters(getFilter);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/getdata`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          filter: { ...cleanedFilter },
          skip:
            paginationModel.page != 0
              ? paginationModel.page * paginationModel.pageSize
              : paginationModel.page,
          count: paginationModel.pageSize,
        }),
      });
      const dataset = await resp.json();
      if (resp.status === 200) {
        if (dataset.status === true) {
          setData(dataset.data);
          setTotalCount(dataset.count);
        } else {
          showToast("Search failed, please try again", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching filtered enteries", error);
      showToast(
        "Failed to search entries. Please check your connection and try again",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchAllEntries = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/getdata`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          filter: {},
          skip:
            paginationModel.page != 0
              ? paginationModel.page * paginationModel.pageSize
              : paginationModel.page,
          count: paginationModel.pageSize,
        }),
      });
      const dataset = await resp.json();
      if (resp.status === 200) {
        if (dataset.status === true) {
          showToast("Data fetched successfully", "success");
          setData(dataset.data);
          setTotalCount(dataset.count);
        } else {
          showToast("Failed to fetch data. PLease try again", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching all entries", error);
      showToast("Network error occured, please try again", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAgentList = async () => {
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          setAgentList(dataset.data.data);
        } else {
          showToast("Failed to fetch agent list, please try again", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching agent list", error);
      showToast(
        "Network error while fetching agents, please try again",
        "error"
      );
    }
  };

  const deleteTicketEntry = async (ticket_id) => {
    setLoading(true);
    try {
      console.log(ticket_id);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          ticket: ticket_id,
        }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          showToast("Entry deleted successfully", "success");
          fetchAllEntries();
        } else {
          showToast("Failed to delete entry, please try again", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error deleting entry", error);
      showToast(
        "Network error occured while deleting, please try again later",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  const exportEnteriesToCSV = async () => {
    try {
      const cleanedFilter = cleanFilters(getFilter);
      const filterString = JSON.stringify(cleanedFilter);
      setHeaderForm(filterString);
      console.log(getHeaderForm);
      document.getElementById("formpost").submit();
      showToast("Export initiated successfully", "success");
    } catch (error) {
      console.log("Error exporting enteries", error);
      showToast("Failed to export entries. Please try again", "error");
    }
  };

  useEffect(() => {
    fetchFilteredEnteries();
    fetchAgentList();
  }, []);

  useEffect(() => {
    fetchFilteredEnteries();
  }, [paginationModel]);

  return (
    <div className="agent_wrapper">
      <div className="top_search_fields">
        <div className="fields_row">
          <div className="fields_item">
            <label>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter name"
              onChange={(e) => {
                setFilter({
                  ...getFilter,
                  [e.target.name]: { $eq: e.target.value },
                });
              }}
            />
          </div>
          <div className="fields_item">
            <label>Amount</label>
            <input
              type="text"
              name="amount"
              placeholder="Enter Amount"
              onChange={(e) => {
                setFilter({
                  ...getFilter,
                  [e.target.name]: { $eq: e.target.value },
                });
              }}
            />
          </div>
          <div className="fields_item">
            <label>Phone</label>
            <input
              type="text"
              name="phone"
              placeholder="Enter Phone"
              onChange={(e) => {
                setFilter({
                  ...getFilter,
                  [e.target.name]: { $eq: e.target.value },
                });
              }}
            />
          </div>
          <div className="fields_item">
            <label>From</label>
            <input
              name="created_time"
              onChange={(e) => {
                var myDate = e.target.value;
                myDate = myDate.split("-");
                console.log(myDate);
                var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
                setFilter({
                  ...getFilter,
                  [e.target.name]: {
                    ...getFilter[e.target.name],
                    $gte: newDate.getTime(),
                  },
                });
              }}
              type="Date"
            />
          </div>
          <div className="fields_item">
            <label>To</label>
            <input
              name="created_time"
              onChange={(e) => {
                var myDate = e.target.value;
                myDate = myDate.split("-");
                console.log(myDate);
                var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
                setFilter({
                  ...getFilter,
                  [e.target.name]: {
                    ...getFilter[e.target.name],
                    $lte: newDate.getTime() + 86399999,
                  },
                });
              }}
              type="Date"
            />
          </div>
        </div>
        <div className="btn_container">
          <button
            onClick={(e) => {
              fetchFilteredEnteries();
            }}
          >
            {loading ? <Loader loading={loading} /> : "Search Entry"}
          </button>
          <button
            onClick={(e) => {
              exportEnteriesToCSV();
            }}
          >
            Export Entry
          </button>
        </div>
        <div style={{ textAlign: "right", marginRight: "20px" }}>
          <select
            defaultValue={paginationModel.pageSize}
            onChange={(e) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: e.target.value,
              });
            }}
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      <div className="table_container">
        <table>
          <tr>
            <th>Sr. No.</th>
            <th>Ticket Number</th>
            <th>Total Amount</th>
            <th>Last Amount</th>
            <th>Last Remark</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Ticket</th>
            <th>Last Contacted By</th>
            <th>Updated Time</th>
            <th>Created Time</th>
            <th>Created By</th>
            <th>Delete</th>
          </tr>
          {getData.map((e, index) => {
            if (Object.keys(e).length == 0) {
              return <tr></tr>;
            } else {
              var dataset = e.data;
              const updatetimeorg = new Date(
                dataset[dataset.length - 1].updated_time
              );
              const createtimeorg = new Date(e.created_time);
              const updatetime = `${
                updatetimeorg.getDate() > 9
                  ? updatetimeorg.getDate()
                  : "0" + updatetimeorg.getDate()
              }/${
                updatetimeorg.getMonth() > 8
                  ? updatetimeorg.getMonth() + 1
                  : "0" + (updatetimeorg.getMonth() + 1)
              }/${updatetimeorg.getFullYear()} ${
                updatetimeorg.getHours() > 9
                  ? updatetimeorg.getHours()
                  : "0" + updatetimeorg.getHours()
              }:${
                updatetimeorg.getMinutes() > 9
                  ? updatetimeorg.getMinutes()
                  : "0" + updatetimeorg.getMinutes()
              }:${
                updatetimeorg.getSeconds() > 9
                  ? updatetimeorg.getSeconds()
                  : "0" + updatetimeorg.getSeconds()
              }`;
              const createtime = `${
                createtimeorg.getDate() > 9
                  ? createtimeorg.getDate()
                  : "0" + createtimeorg.getDate()
              }/${
                createtimeorg.getMonth() > 8
                  ? createtimeorg.getMonth() + 1
                  : "0" + (createtimeorg.getMonth() + 1)
              }/${createtimeorg.getFullYear()} ${
                createtimeorg.getHours() > 9
                  ? createtimeorg.getHours()
                  : "0" + createtimeorg.getHours()
              }:${
                createtimeorg.getMinutes() > 9
                  ? createtimeorg.getMinutes()
                  : "0" + createtimeorg.getMinutes()
              }:${
                createtimeorg.getSeconds() > 9
                  ? createtimeorg.getSeconds()
                  : "0" + createtimeorg.getSeconds()
              }`;
              return (
                <tr>
                  <td style={{ fontWeight: 500, textDecoration: "underline" }}>
                    {index + 1}
                  </td>
                  <td>{e.ticket_no}</td>
                  <td>₹{(e.amount / 100).toLocaleString("en-IN")}</td>
                  <td>
                    ₹
                    {(dataset[dataset.length - 1].amount / 100).toLocaleString(
                      "en-IN"
                    ) == "NaN"
                      ? "0"
                      : (
                          dataset[dataset.length - 1].amount / 100
                        ).toLocaleString("en-IN")}
                  </td>
                  <td>{dataset[dataset.length - 1].remark}</td>
                  <td>{e.name}</td>
                  <td>{e.phone}</td>
                  <td>{e.ticket}</td>
                  <td>{dataset[dataset.length - 1].entry_name}</td>
                  <td>{updatetime}</td>
                  <td>{createtime}</td>
                  <td>{dataset[0].entry_name}</td>
                  <td>
                    <div className="btn_container">
                      <button
                        onClick={(f) => {
                          deleteTicketEntry(e.ticket);
                        }}
                      >
                        {loading ? (
                          <Loader loading={loading} />
                        ) : (
                          "Delete Entry"
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            }
          })}
        </table>
      </div>
      <div className="btn_container">
        {paginationModel.page > 0 ? (
          <button
            className="table_btn"
            onClick={(e) => {
              console.log(paginationModel);
              setPaginationModel({
                ...paginationModel,
                page: paginationModel.page - 1,
              });
            }}
          >
            Back
          </button>
        ) : (
          <></>
        )}

        {getTotalCount / paginationModel.pageSize >= 1 ? (
          <button className="table_btn">
            {paginationModel.page + 1} of{" "}
            {Math.round(getTotalCount / paginationModel.pageSize)}
          </button>
        ) : (
          <button className="table_btn">{1}</button>
        )}

        {paginationModel.page + 1 < getTotalCount / paginationModel.pageSize ? (
          <button
            className="table_btn"
            onClick={(e) => {
              console.log(paginationModel);
              setPaginationModel({
                ...paginationModel,
                page: paginationModel.page + 1,
              });
            }}
          >
            Next
          </button>
        ) : (
          <></>
        )}
      </div>
      <br />
      <form
        id="formpost"
        style={{ display: "none" }}
        action={`${process.env.REACT_APP_URL}/admin/export`}
        target="_blank"
        method="POST"
      >
        <input name="token" value={cookie.get("admin")}></input>
        <input name="filter" value={getHeaderForm}></input>
        <input type="submit"></input>
      </form>
    </div>
  );
};

export default Admindata;
